import React, {
  createContext, useContext, useMemo, useState,
} from 'react';
import { absMonthToDate, resolveRange } from './components/SuperDatePicker/utils';

const defaultValue = {
  range: { start: undefined, end: undefined },
  setRange: () => {},
  get value() {
    return [];
  },
};
const context = createContext(defaultValue);

export default function GlobalDateContext({ initRange = absMonthToDate, children }) {
  const [range, setRange] = useState(initRange);

  const value = useMemo(() => ({
    range,
    setRange,
    get value() {
      return resolveRange(range);
    },
  }), [range]);

  return <context.Provider value={value}>{children}</context.Provider>;
}

export const useGlobalDate = () => useContext(context);
